import React from "react";
import { Card, CardContent } from "../ui/card";
import add_img from "../../images/add_sec.svg";

/**
 * Add Section - Orange promotional card
 * Modernized with Shadcn Card component
 */
function Add_sec() {
    return (
        <Card className="bg-gradient-to-br from-orange-400 to-orange-500 border-0 overflow-hidden h-full">
            <CardContent className="p-6 flex flex-col items-center justify-center text-center h-full min-h-[400px]">
                <h3 className="text-2xl md:text-3xl font-black text-white leading-tight mb-6">
                    Refer today &<br />
                    <span className="text-3xl md:text-4xl">Earn Cash</span><br />
                    <span className="text-3xl md:text-4xl">Every Time!</span>
                </h3>
                <div className="mt-auto">
                    <img 
                        src={add_img} 
                        alt="Earn Cash" 
                        className="w-full max-w-[200px] mx-auto"
                    />
                </div>
            </CardContent>
        </Card>
    );
}

export default Add_sec;
